import type { ComponentType } from "react";
import GizmoAppMinigameCreation from "./pages/GizmoAppMinigameCreation";
import GyroStabilisedSpoon from "./pages/GyroStabilisedSpoon";
import PersonalityDrivenHydroponicsMonitoringSystem from "./pages/PersonalityDrivenHydroponicsMonitoringSystem";

export const projectPages: Record<string, ComponentType> = {
  "1": PersonalityDrivenHydroponicsMonitoringSystem,
  "2": GizmoAppMinigameCreation,
  "3": GyroStabilisedSpoon,
};
